import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'c3m-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent {
  constructor() {}
}
